import React, { useCallback, useEffect, useState } from 'react';
import { genericRequest } from 'app/api';
import { useLang } from 'app/context/i18n';
import posthog from 'posthog-js';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Chip from '../Chip';
import Icon from '../Icon';

function Version() {
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();

  const [version, setVersion] = useState(null);
  const locale = useLang();

  const fetchData = useCallback(async (controller) => {
    const result = await genericRequest({
      url: `https://cms-gateway.bigbuy.eu/controlpanel/version?locale=${locale}&preview=true`,
      signal: controller?.signal || null,
      getHeaders: true
    });

    setVersion(result?.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller);
    return () => {
      setVersion(null);
      controller.abort();
    };
  }, [fetchData]);

  if (!version) {
    return null;
  }

  const isVersionAlreadyVisitted =
    version.versionId &&
    localStorage.getItem('visitedVersion') === version.versionId;

  const chipMessage = !isVersionAlreadyVisitted ? 'New' : undefined;

  const handleClick = () => {
    posthog.capture('news_section_clicked', {
      user_id: user?.id,
      language: locale,
      page_location: location?.pathname
    });
    localStorage.setItem('visitedVersion', version.versionId);
  };

  return (
    <li className="menu-item version-container">
      <a
        className="menu-link"
        href={version.url}
        target="_blank"
        rel="noreferrer"
        onClick={handleClick}
      >
        <div className="version">
          <span className="menu-icon">
            <Icon icon="megaphone" color="#f2b801" />
          </span>
          <p className="menu-text">{version.text}</p>
          {chipMessage && <Chip text={chipMessage} color="#0090ff" />}
        </div>
      </a>
    </li>
  );
}

export default Version;
